import { apiClient } from "./client";
import { ApiResponse } from "../types";

export interface BuildVersionsInfoResponse {
  build_versions: Array<{
    build_version_id: string;
    name: string;
    enabled?: boolean;
    display_order?: number;
  }>;
}

export interface ExecutionEnvironmentsInfoResponse {
  test_execution_environments: Array<{
    execution_environment_id: string;
    name: string;
    display_order?: number;
    value?: string;
  }>;
}

export class EnvironmentAPI {
  static async getBuildVersions(
    projectId: string
  ): Promise<ApiResponse<BuildVersionsInfoResponse>> {
    return apiClient.get<BuildVersionsInfoResponse>(
      `/project_environments/build_versions`,
      { project_id: projectId }
    );
  }

  static async getExecutionEnvironments(
    projectId: string
  ): Promise<ApiResponse<ExecutionEnvironmentsInfoResponse>> {
    return apiClient.get<ExecutionEnvironmentsInfoResponse>(
      `/project_environments/execution_environments`,
      { project_id: projectId }
    );
  }
}

export default EnvironmentAPI;
